import Brightness4OutlinedIcon from '@mui/icons-material/Brightness4Outlined'
import Brightness7OutlinedIcon from '@mui/icons-material/Brightness7Outlined'
import { IconButton, Tooltip, useMediaQuery } from '@mui/material'
import { useTheme, useThemesContext, useTranslate } from 'react-admin'

const ThemeToggleButton = () => {
  const translate = useTranslate()
  const { darkTheme, defaultTheme } = useThemesContext()
  const prefersDarkMode = useMediaQuery('(prefers-color-scheme: dark)', { noSsr: true })
  const [theme, setTheme] = useTheme(defaultTheme || (prefersDarkMode && darkTheme ? 'dark' : 'light'))
  const title = translate('ra.action.toggle_theme', { _: 'Toggle Theme' })

  return (
    <Tooltip title={title} enterDelay={300}>
      <IconButton color="inherit" aria-label={title} onClick={() => setTheme(theme === 'dark' ? 'light' : 'dark')}>
        {theme === 'dark' ? <Brightness7OutlinedIcon /> : <Brightness4OutlinedIcon />}
      </IconButton>
    </Tooltip>
  )
}

export default ThemeToggleButton
